import React, {useState} from 'react';
import {motion} from 'framer-motion';
import './CallToAction.css';

const CallToAction: React.FC = () => {
  const [email, setEmail] = useState('');
  const [isSubmitted, setIsSubmitted] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (!email || isLoading) return;

    setIsLoading(true);

    try {
      const response = await fetch('MailScript.php', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
        },
        body: `email=${encodeURIComponent(email)}`,
      });

      const data = await response.json();

      if (data.success) {
        setIsSubmitted(true);
        setEmail('');
        setTimeout(() => setIsSubmitted(false), 3000);
      } else {
        alert(data.message || 'Submission failed.');
      }
    } catch (error) {
      console.error('Signup error:', error);
      alert('An error occurred. Please try again.');
    } finally {
      setIsLoading(false);
    }
  };

  return (
      <section className="call-to-action">
        <motion.div
            className="cta-container"
            initial={{opacity: 0, y: 50}}
            animate={{opacity: 1, y: 0}}
            transition={{duration: 1, delay: 4}}
        >
          <motion.h2
              className="cta-title"
              initial={{opacity: 0}}
              animate={{opacity: 1}}
              transition={{delay: 4.5}}
          >
            Get on the waitlist
          </motion.h2>

          <motion.p
              className="cta-subtitle"
              initial={{opacity: 0}}
              animate={{opacity: 1}}
              transition={{delay: 4.7}}
          >
            The Next Generation of <span className="text-bold-italic">collaboration</span>. Starting with 5 Teams.
          </motion.p>

          <motion.form
              className="signup-form"
              onSubmit={handleSubmit}
              initial={{opacity: 0, scale: 0.9}}
              animate={{opacity: 1, scale: 1}}
              transition={{delay: 5}}
          >
            <div className="form-group">
              <input
                  type="email"
                  placeholder="Enter your email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  className="email-input"
                  required
                  disabled={isLoading || isSubmitted}
              />
              <motion.button
                  type="submit"
                  className="submit-button"
                  whileHover={{scale: 1.05}}
                  whileTap={{scale: 0.95}}
                  disabled={isSubmitted || isLoading}
              >
                {isSubmitted ? 'Welcome!' : isLoading ? 'Joining...' : 'Join Pilot Phase'}
                <div className="button-glow"></div>
              </motion.button>
            </div>

            {isSubmitted && (
                <motion.p
                    className="success-message"
                    initial={{opacity: 0, y: 10}}
                    animate={{opacity: 1, y: 0}}
                >
                  Thank you! We'll be in touch soon.
                </motion.p>
            )}
          </motion.form>
        </motion.div>
      </section>
  );
};

export default CallToAction;